import {
  Box,
  Button,
  Checkbox,
  Grid,
  Group,
  LoadingOverlay,
  NumberInput,
  TextInput,
  Textarea,
} from "@mantine/core";
import { hasLength, useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import { IconCheck, IconWindow } from "@tabler/icons-react";
import { useEffect, useState } from "react";
import { repositoryMdm } from "../../../../_base/_const/_constVar";
import { NotificationExtension } from "../../../../_base/extension/NotificationExtension";
import { MessageResponse } from "../../../../model/MessageResponse";
import { TblDMReturnRate } from "../../../../model/TblDMReturnRate";
import { sky_blue } from "../../../../const/variables";

const EditDataView = ({ id, onClose }: EditDataViewProps) => {
  const entity = {
    id: "0",
    fromDate: 0,
    toDate: 0,
    returnRate: 0,
    note: null,
    active: false,
    updateDate: null,
    createDate: null,
    levelName: null,
    createBy: null,
    lastUpdateBy: null,
    lastUpdateDate: null,
  };

  const [visible, { toggle, close, open }] = useDisclosure(false);
  const [enable, setEnable] = useState(false);

  const form = useForm<TblDMReturnRate>({
    mode: "controlled",
    validateInputOnChange: true,
    initialValues: {
      ...entity,
    },

    validate: {
      fromDate: (value: number | null) => {
        if (!value) {
          return "Vui lòng nhập từ số ngày!";
        }
      },
      toDate: (value: number | null) => {
        if (!value) {
          return "Vui lòng nhập đến số ngày!";
        }
      },
      levelName: (value: string | null) => {
        if (!value) {
          return "Vui lòng nhập tên mức!";
        }
        return hasLength(
          { max: 100 },
          "Tên phải nhỏ hơn 100 kí tự!"
        )(value as string);
      },
      note: (value: string | null) => {
        if (value)
          return hasLength(
            { max: 100 },
            "Ghi chú phải nhỏ hơn 1000 kí tự!"
          )(value as string);
      },
    },
  });

  const handleEditTblDMReturnRate = async (dataSubmit: TblDMReturnRate) => {
    open();
    const dataApi = await repositoryMdm.post<MessageResponse<TblDMReturnRate>>(
      "/api/v1/TblDmReturnRate/update",
      dataSubmit
    );
    if (dataApi?.success) {
      onClose((prev: any) => !prev);
      modals.closeAll();
      NotificationExtension.Success("Cập nhật thành công!!!");
    }

    close();
  };

  const callApiGetData = async () => {
    open();
    const callapi = await repositoryMdm.get<MessageResponse<TblDMReturnRate>>(
      `/api/v1/TblDmReturnRate/update?id=${id}`
    );
    if (!callapi?.success) {
      NotificationExtension.Fails("Bạn không có quyền sửa!!!");
      modals.closeAll();
      return;
    }
    if (callapi) {
      const dataApi = callapi?.data;
      if (dataApi != null) {
        form.setValues(dataApi);
        form.resetDirty(dataApi);
      }
      close();
    } else {
      NotificationExtension.Fails("Dữ liệu không tồn tại");
      modals.closeAll();
    }
  };

  useEffect(() => {
    if (id) {
      callApiGetData();
    }
  }, [id]);

  useEffect(() => {
    if (form.isDirty()) {
      setEnable(true);
    } else {
      setEnable(false);
    }
  }, [form]);

  return (
    <>
      <Box
        component="form"
        mx="auto"
        onSubmit={form.onSubmit((e: TblDMReturnRate) => {
          handleEditTblDMReturnRate(e);
        })}
        style={{ position: "relative" }}
      >
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 2 }}
        />

        <Grid mt={10}>
          <Grid.Col span={6}>
            <TextInput
              label={"Từ số ngày"}
              placeholder={"Nhập từ số ngày"}
              min={0}
              withAsterisk
              type="number"
              {...form.getInputProps("fromDate")}
            />
          </Grid.Col>
          <Grid.Col span={6}>
            <TextInput
              label={"Đến số ngày"}
              placeholder={"Nhập đến số ngày"}
              min={0}
              withAsterisk
              type="number"
              {...form.getInputProps("toDate")}
            />
          </Grid.Col>
        </Grid>

        <Grid>
          <Grid.Col span={6}>
            <TextInput
              label={"Tên mức"}
              placeholder={"Nhập tên mức"}
              withAsterisk
              {...form.getInputProps("levelName")}
            />
          </Grid.Col>
          <Grid.Col span={6}>
            <NumberInput
              label={"Tỷ lệ nhập lại"}
              placeholder={"Nhập tỷ lệ nhập lại"}
              min={0}
              hideControls
              {...form.getInputProps("returnRate")}
            />
          </Grid.Col>
        </Grid>

        <Group grow wrap="nowrap" mb={"md"} gap={"lg"} align="center">
          <Textarea
            label={"Ghi chú"}
            placeholder="Nhập ghi chú"
            w={"100%"}
            {...form.getInputProps("note")}
          />
        </Group>
        <Checkbox
          label={"Sử dụng"}
          checked={form.values.active}
          {...form.getInputProps("active")}
        />

        <Group
          justify="end"
          mt="xs"
          style={{
            position: "sticky",
            bottom: 0,
            backgroundColor: "white",
          }}
        >
          <Button
            type="button"
            color="gray"
            loading={visible}
            onClick={() => {
              modals.closeAll();
            }}
            leftSection={!visible ? <IconWindow size={18} /> : undefined}
          >
            Đóng
          </Button>
          <Button
            type="submit"
            color={sky_blue.base}
            disabled={!enable}
            loading={visible}
            leftSection={!visible ? <IconCheck size={18} /> : undefined}
          >
            Lưu
          </Button>
          <></>
        </Group>
      </Box>
    </>
  );
};

export default EditDataView;

type EditDataViewProps = {
  id: string | number;
  onClose: any;
};
